
import Swiper from 'swiper/bundle';


document.addEventListener('DOMContentLoaded', () => {

  const swiperRooms = new Swiper(".services-swiper", {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 20,
    speed: 1500,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    pagination: {
      el: ".swiper-pagination_serv",
      clickable: true,
    },
  });


});